module.exports = __webpack_public_path__ + "static/media/CloseXPurple.7df02fcc.svg";